module.exports = __webpack_public_path__ + "media/images/banner/kickstarter/foodbook_banner_v3-189ed2ab3154a38d111b6072afaa436d.jpeg";